/**
 * Router Navigation Utility
 * Provides a way to access React Router's navigation from outside React components
 */

let navigateFunction: ((path: string) => void) | null = null;

export const setNavigate = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
  // Also expose it globally for API client
  if (typeof window !== 'undefined') {
    (window as Window & { __REACT_ROUTER_NAVIGATE__?: typeof navigate }).__REACT_ROUTER_NAVIGATE__ =
      navigate;
  }
};

export const getNavigate = () => navigateFunction;

export const navigateTo = (path: string) => {
  if (navigateFunction) {
    navigateFunction(path);
  } else if (typeof window !== 'undefined') {
    // Fallback to hard navigation
    window.location.href = path;
  }
};
